<script>
  import Vue from 'vue';
  import store from 'store';
  import sellerStore from 'store/indexSeller';
  import {isCurrentAppSeller} from 'utils/appTypeState';

  const getStoreModule = () => isCurrentAppSeller() ? sellerStore : store;

  export default {
    name: 'MModalMixin',
    data () {
      return {
        modalComponent: null, // MModal component, should be specified in component
        modalProps: {}, // props that are passed to modal
        modalEventListeners: {}, // modal event listeners

        // internal use :D, do not override
        modalNode: null, // modal node
        prevOverflow: null // prev overflow state of <body>
      };
    },
    beforeDestroy () {

      // remove modal if parent component is destroying (f.e. url change)
      this.hidePopup();
    },
    methods: {
      showPopup () {
        this.modalNode = new Vue({
          store: getStoreModule(),
          render: (h) => h(this.modalComponent, {
            props: this.modalProps,
            on: {
              ...this.modalEventListeners,
              close: () => {
                this.modalEventListeners?.close?.();
                this.hidePopup();
              }
            }
          })
        }).$mount();

        document.body.append(this.modalNode.$el);
      },
      hidePopup () {
        if (!this.modalNode) {
          return;
        }
        const modalComponent = this.modalNode.$children[0];
        const removeModalFn = modalComponent?.removeModal || modalComponent.$children[0]?.removeModal;

        try {
          removeModalFn().
            then(() => {

              // during double click there may be race condition with 2 promises, do nothing if modal is already deleted
              if (this.modalNode) {
                this.modalNode.$el.remove();
                this.modalNode.$destroy();
                this.modalNode = null;
              }
            });
        } catch (e) {
          console.warn(e);
        }
      }
    }
  };
</script>
